/** Mescla a busca e move filtros alterados para o fim, como filterContext do legado. */
export function applySearchPatch(
  previous: Record<string, unknown>,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const kept = Object.entries(previous).filter(
    ([key, value]) =>
      !(key in patch) ||
      (patch[key] !== undefined && JSON.stringify(patch[key]) === JSON.stringify(value)),
  );
  const changed = Object.entries(patch).filter(
    ([key, value]) =>
      value !== undefined && JSON.stringify(value) !== JSON.stringify(previous[key]),
  );
  return Object.fromEntries([...kept, ...changed]);
}
